
















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { CompPage } from '@/config/components/type'
import CodePreview from './layout/code-preview/index.vue'
import ApiTable from './layout/api-table/index.vue'

@Component({
  components: { CodePreview, ApiTable }
})
export default class ComponentPage extends Vue {
  @Prop() comp!: CompPage

  loading = false

  get summary () {
    return this.comp?.summary || ''
  }

  @Watch('comp', { immediate: true }) compChange () {
    this.loading = true
    setTimeout(() => {
      this.loading = false
    }, 500)
  }
}
